import React, { useRef, useEffect } from 'react';
import { userInitialValues, userValidationSchema, Gender, getGender,configurations, getClinicList, getDepartmentbyclinic, Clinic, Department, getConfigurations, getRoleList, Role, UserInitialValues, postUserDetails, putUserDetails, getUserDetails, checkUserAvailability, getLanguageList } from './UserDetails.helper';
import { Form, Formik } from 'formik';
import { Button, FormControlLabel, Radio, RadioGroup, TextField, Avatar, IconButton, Typography, Box, Autocomplete, Grid2, Table, TableHead, TableBody, TableRow, TableCell, Checkbox } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { styled, ThemeProvider } from '@mui/material/styles';
import { RequiredLabel } from '../../../../utils/commonUtils';
import { useTranslation } from 'react-i18next';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { theme } from '../../../../theme';
import { ImageUploadModal, UploadButton, UploadedImageType } from '../../../../components/common/ImageUploadModal';
import { useAlert } from '../../../../components/alertProvider';
import { useLoader } from '../../../../components/loaderProvider/loader';
import { ConfirmationModal } from '../../../../components/confirmationModal';
import { useNavigate, useLocation } from 'react-router-dom';

const Input = styled('input')({ display: 'none' });


const AddUser: React.FC = () => {
  
  const topRef = useRef<HTMLDivElement>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [avatarBase64, setAvatarBase64] = React.useState<string | undefined>(undefined);
  const [genderOptions, setGenderOptions] = React.useState<Gender[]>([]);
  const [clinicOptions, setClinicOptions] = React.useState<Clinic[]>([]);
  const [departmentOptions, setDepartmentOptions] = React.useState<Department[]>([]);
  const [userDetailsInitials, setuserDetailsInitials] = React.useState<UserInitialValues>(userInitialValues);
  const [selectedClinic, setSelectedClinic] = React.useState<Clinic | null>(null);
  const [selectedDepartment, setSelectedDepartment] = React.useState<Department | Department[] | null>(null);
  const [genderLoading, setGenderLoading] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const [uploadModalOpen, setUploadModalOpen] = React.useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = React.useState(false);
  const [uploadedFiles, setUploadedFiles] = React.useState<UploadedImageType[]>([]);
  const {t} = useTranslation('user_config');
  const {t:tGeneral} = useTranslation('general');
  const {t:tSurgery} = useTranslation('surgery_config');
  const [activeTab, setActiveTab] = React.useState(0);
  const [configurations, setConfigurations] = React.useState<configurations | null>(null);
  const [roleOptions, setRoleOptions] = React.useState<Role[]>([]);
  const [doctorCategoryOptions, setDoctorCategoryOptions] = React.useState<Role[]>([]);
  const [languageOptions, setLanguageOptions] = React.useState<{code: string; name: string; id: number}[]>([]);
  const [openConfirmDialog, setOpenConfirmDialog] = React.useState(false);
  const { addAlert } = useAlert();
  const { showLoader, hideLoader } = useLoader();
  const navigate = useNavigate();
  const location = useLocation();
  const editUserId = location.state?.userId;
  const [usernameError, setUsernameError] = React.useState<string>('');
  const [usernameSuccess, setUsernameSuccess] = React.useState<string>('');
  const [avatarError, setAvatarError] = React.useState('');
  const tabList = [
    'Personal Information',
    'Clinical Departments',
    'Bank Information',
    'Address Information'
  ];
  const tabFieldMap = [
    [
      'additional_info.pan_number'
    ],
    ['clinic_departments'],
    [
      'additional_info.bank_name', 'additional_info.branch_name', 'additional_info.account_number', 'additional_info.ifsc', 'additional_info.address'
    ],
    [
      'additional_info.permenant_address_line1', 'additional_info.permenant_address_line2', 'additional_info.permenant_city', 'additional_info.permenant_state', 'additional_info.permenant_country', 'additional_info.permenant_pincode',
      'additional_info.communication_address_line1', 'additional_info.communication_address_line2', 'additional_info.communication_city', 'additional_info.communication_state', 'additional_info.communication_country', 'additional_info.communication_pincode', 'additional_info.address_same_as_permenant'
    ]
  ];
  useEffect(() => {
    const fetchGenders = async () => {
      setGenderLoading(true);
      try {
        const response = await getGender();
        setGenderOptions(response.objects);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to fetch genders', error);
      } finally {
        setGenderLoading(false);
      }
    };
    const fetchClinics = async () => {
      try {
        const response = await getClinicList();
        setClinicOptions(response.objects); 
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to fetch clinics', error);
      }
    };
    const fetchConfigurations = async () => {
      try {
        const response = await getConfigurations();
        setConfigurations(response);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to fetch configurations', error);
      }
    };
    const fetchRoles = async () => {
      try {
        const response = await getRoleList(false);
        setRoleOptions(response.objects);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to fetch roles', error);
      }
    };
    const fetchDoctorCategories = async () => {
      try {
        const response = await getRoleList(true);
        setDoctorCategoryOptions(response.objects);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to fetch doctor categories', error);
      }
    };
    const fetchlanguages = async () => {
      try {
        const response = await getLanguageList();
        setLanguageOptions(response);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to fetch languages', error);
      }
    };
    fetchGenders();
    fetchClinics();
    fetchConfigurations();
    fetchRoles();
    fetchDoctorCategories();
    fetchlanguages();
  }, []);

  useEffect(() => {

    if (editUserId) {
      const fetchUserDetails = async () => {
        try {
          const response = await getUserDetails(editUserId);
          setuserDetailsInitials(response);
          setAvatarBase64(response.photo);
          
          // Load existing files into uploadedFiles state for edit mode
          if (response.files && response.files.length > 0) {
            const existingFiles: UploadedImageType[] = response.files.map((fileObj, index) => {
              // Use file_name from API if available, otherwise determine from base64 data
              let fileName = fileObj.file_name || `Document_${index + 1}`;
              let fileExtension = fileObj.file_extension || '';
              const fileSize = fileObj.file_size;
              
              // If no file_name from API, determine from base64 data
              if (!fileObj.file_name && fileObj.file && typeof fileObj.file === 'string') {
                const match = fileObj.file.match(/^data:(.*?);/);
                const fileType = match ? match[1] : '';
                if (fileType.includes('pdf')) {
                  fileName = `Document_${index + 1}.pdf`;
                  fileExtension = 'pdf';
                } else if (fileType.includes('jpeg') || fileType.includes('jpg')) {
                  fileName = `Document_${index + 1}.jpg`;
                  fileExtension = 'jpg';
                } else if (fileType.includes('png')) {
                  fileName = `Document_${index + 1}.png`;
                  fileExtension = 'png';
                }
              }
              return {
                name: fileName,
                image: fileObj.file || '',
                file_extension: fileExtension,
                sizeBytes: fileSize,
                size: fileSize ? (fileSize / (1024 * 1024)).toFixed(2) : undefined,
                isExisting: true,
              };
            });
            setUploadedFiles(existingFiles);
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Failed to fetch user details', error);
        }
      };
      fetchUserDetails();
    }
  }, [editUserId]);
  useEffect(() => {
    const fetchDepartments = async () => {
      if (selectedClinic) {
        try {
          const response = await getDepartmentbyclinic(selectedClinic.id);
          setDepartmentOptions(response.objects);
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Failed to fetch departments', error);
        }
      } else {
        setDepartmentOptions([]);
      }
    };
    fetchDepartments();
  }, [selectedClinic]);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>, setFieldValue: any) => {
    const file = e.target.files && e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setAvatarBase64(reader.result as string);
        setFieldValue('photo', reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const isEqual = (a: any, b: any) => {
    if (typeof a !== typeof b) return false;
    if (typeof a === 'object' && a !== null && b !== null) {
      const aKeys = Object.keys(a);
      const bKeys = Object.keys(b);
      if (aKeys.length !== bKeys.length) return false;
      for (const key of aKeys) {
        if (!isEqual(a[key], b[key])) return false;
      }
      return true;
    }
    return a === b;
  };

  const handleSubmit = async (
    values: UserInitialValues
  ) => {
    showLoader();

    if (editUserId) {
      // Always send language code, not id
      let languageCode = values.language;
      // If language is a number (id), map to code
      if (!isNaN(Number(languageCode))) {
        const foundLang = languageOptions.find(opt => String(opt.id) === String(languageCode));
        languageCode = foundLang ? foundLang.code : languageCode;
      }
      const changedFields: Record<string, unknown> = {
        first_name: values.first_name,
        last_name: values.last_name,
        username: values.username,
        email: values.email,
        language: languageCode
      };

      Object.keys(values).forEach((key) => {
        if (
          key !== 'first_name' &&
          key !== 'last_name' &&
          key !== 'username' &&
          key !== 'email' &&
          key !== 'language'

        ) {
          const oldValue = userDetailsInitials[key as keyof UserInitialValues];
          const newValue = values[key as keyof UserInitialValues];
          if (!isEqual(newValue, oldValue)) {
            changedFields[key as keyof UserInitialValues] = newValue;
          }
        }
      });

      putUserDetails(editUserId, changedFields)
        .then(() => {
          addAlert('User Updated Successfully', 'success');
          navigate('/ai/configuration/user');
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.error('Error updating user details:', error);
        })
        .finally(() => {
          hideLoader();
        });
    } else {
      postUserDetails(values)
        .then(() => {
          addAlert('User Created Successfully', 'success');
          navigate('/ai/configuration/user');
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.error('Error submitting user details:', error);
        })
        .finally(() => {
          hideLoader();
        });
    }
  };

  const editValidationSchema = userValidationSchema.pick([
    'first_name',
    'last_name',
    'username',
    'email',
    'language'
  ]);
 
  return ( 
    <Formik
      initialValues={userDetailsInitials}
      enableReinitialize
      validationSchema={editUserId ? editValidationSchema : userValidationSchema}
      onSubmit={handleSubmit}
    >
      {({ values, errors, touched, handleChange, setFieldValue, validateForm, isSubmitting, setFieldTouched, submitForm }) => {
        if (!values.additional_info || typeof values.additional_info !== 'object') {
          setFieldValue('additional_info', {});
        }


        const handleUsernameChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
          const value = e.target.value;
          setFieldValue('username', value);
          setUsernameError('');
          setUsernameSuccess('');
          if (value && value.length > 2) {
            try {
              const status = await checkUserAvailability(value);
              if (!status.available) {
                setUsernameError(status.message);
                setUsernameSuccess('');
              } else {
                setUsernameSuccess(status.message);
                setUsernameError('');
              }
            } catch {
              setUsernameError(t('AddUser.UsernameCheckError'));
              setUsernameSuccess('');
            }
          }
        };
        const getPasswordHelperText = () => {
          if (errors.password) {
            if (
              errors.password === t('AddUser.PasswordRequired') ||
      errors.password === 'Password is required'
            ) {
              return { text: '', color: undefined };
            }
            return { text: errors.password, color: '#d32f2f' };
          }
          return { text: '', color: undefined };
        };

        const getConfirmPasswordHelperText = () => {
          if (errors.confirm_password) {
            if (
              errors.confirm_password === t('AddUser.ConfirmPasswordRequired') ||
      errors.confirm_password === 'Confirm Password is required'
            ) {
              return { text: '', color: undefined };
            }
            return { text: errors.confirm_password, color: '#d32f2f' };
          }
          return { text: '', color: undefined };
        };
        return (
          <ThemeProvider theme={theme}>
            <Box sx={{ padding: 3 }} ref={topRef}>
              <Form
                onSubmit={e => {
                  e.preventDefault();
                  setAvatarError('');
                  validateForm().then((formErrors) => {
                    let firstErrorTab = 0;
                    for (let i = 0; i < tabFieldMap.length; i++) {
                      const tabFields = tabFieldMap[i];
                      if (tabFields.some(field => {
                        const keys = field.split('.');
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        let errObj: any = formErrors;
                        for (const k of keys) {
                          if (errObj && typeof errObj === 'object') errObj = errObj[k];
                          else errObj = undefined;
                        }
                        return !!errObj;
                      })) {
                        firstErrorTab = i;
                        break;
                      }
                    }
                    setActiveTab(firstErrorTab);
                    if (!avatarBase64) {
                      setAvatarError('Profile picture is required.');
                      if (topRef.current) {
                        topRef.current.scrollIntoView({ behavior: 'smooth' });
                      }
                    }
                    if ((Object.keys(formErrors).length > 0 || !avatarBase64) || isSubmitting) {
                      // Mark all fields as touched to show errors
                      Object.keys(values).forEach((field) => {
                        setFieldTouched(field, true, false);
                      });
                      // Also mark nested additional_info fields as touched
                      if (values.additional_info && typeof values.additional_info === 'object') {
                        Object.keys(values.additional_info).forEach((field) => {
                          setFieldTouched(`additional_info.${field}`, true, false);
                        });
                      }
                      return;
                    }
                    setOpenConfirmDialog(true);
                  });
                }}
              >
                <Box sx={{ mb: 3 }}>

                  <Box sx={{ display: 'flex', alignItems: 'center'}}>
                    <Box sx={{ position: 'relative', mr: 3 }}>
                      <Avatar
                        src={avatarBase64}
                        sx={{ width: 80, height: 80 }}
                      />
                      <IconButton
                        sx={{
                          position: 'absolute',
                          bottom: 0,
                          right: 0,
                          background: '#fff',
                          border: '1px solid #E25E3E',
                          color: '#E25E3E',
                          p: 0.5,
                          '&:hover': { background: '#f5f5f5' }
                        }}
                        onClick={() => fileInputRef.current?.click()}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                      <Input
                        accept="image/*"
                        id="profile-picture-upload"
                        type="file"
                        ref={fileInputRef}
                        onChange={e => handleImageChange(e, setFieldValue)}
                      />
                    </Box>

                    <Box>
                      <Typography variant="h6" fontWeight={700} sx={{ mb: 0.5 }}>
                        {editUserId?t('AddUser.UpdateUser') :t('AddUser.Title')}
                      </Typography>
                    </Box>
                    <Box sx={{ flex: 1 }} />
                    <RadioGroup
                      row
                      name="is_doctor"
                      value={values.user_type === 'DOCTOR' ? 'Doctor' : 'Employee'}
                      onChange={e => setFieldValue('user_type', e.target.value === 'Doctor' ? 'DOCTOR' : 'EMPLOYEE')}
                      sx={{ alignItems: 'center', mr: 2 }}
                    >
                      <FormControlLabel value="Employee" control={<Radio color="error" />} label={t('AddUser.Employee')} />
                      <FormControlLabel value="Doctor" control={<Radio color="error" />} label={t('AddUser.Doctor')} />
                    </RadioGroup>

                  </Box>
                  {avatarError && (
                    <Typography color="error" sx={{ mt: 1, fontSize: 14 }}>
                      {avatarError}
                    </Typography>
                  )}
                </Box>

                <Grid2 container spacing={3}>
                  <Grid2 size={{xs:6, md:4, lg:3}}>
                    <TextField
                      name="first_name"
                      label={RequiredLabel(t('AddUser.FirstName'), true)}
                      size="small"
                      value={values.first_name}
                      onChange={handleChange}
                      error={touched.first_name && !!errors.first_name}
                      fullWidth
                      variant="outlined"
                    />
                  </Grid2>
                  <Grid2 size={{xs:6, md:4, lg:3}}>
                    <TextField
                      name="last_name"
                      label={RequiredLabel(t('AddUser.LastName'), true)}
                      size="small"
                      value={values.last_name}
                      onChange={handleChange}
                      error={touched.last_name && !!errors.last_name}
                      fullWidth
                      variant="outlined"
                    />
                  </Grid2>
                  <Grid2 size={{xs:6, md:4, lg:3}}>
                    <Autocomplete
                      options={genderOptions}
                      loading={genderLoading}
                      
                      getOptionLabel={option => option.name_label || option.name}
                      value={genderOptions?.find(opt => opt.id === values.gender) || null}
                      onChange={(_, newValue) => setFieldValue('gender', newValue ? newValue.id : '')}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="gender"
                          label={RequiredLabel(t('AddUser.Gender'), true)}
                          size="small"
                          error={touched.gender && !!errors.gender}
                          variant="outlined"
                        />
                      )}
                      fullWidth
                      isOptionEqualToValue={(option, value) => option.id === value.id}
                    />
                  </Grid2>
                  <Grid2 size={{xs:6, md:4, lg:3}}>
                    <TextField
                      name="dob"
                      label={RequiredLabel(t('AddUser.DOB'), true)}
                      type="date"
                      size="small"
                      value={values.dob || ''}
                      onChange={handleChange}
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      variant="outlined"
                      error={touched.dob && !!errors.dob}
                    />
                  </Grid2>
                  <Grid2 size={{xs:6, md:4, lg:3}}>
                    <TextField
                      name="doj"
                      size="small"
                      label={RequiredLabel(t('AddUser.DOJ'), true)}
                      type="date"
                      value={values.doj || ''}
                      onChange={handleChange}
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      variant="outlined"
                      error={touched.doj && !!errors.doj}
                    />
                  </Grid2>
                  <Grid2 size={{xs:6, md:4, lg:3}}>
                    <TextField
                      name="email"
                      size="small"
                      label={RequiredLabel(t('AddUser.Email'), true)}
                      value={values.email}
                      onChange={handleChange}
                      error={touched.email && !!errors.email}
                      fullWidth
                      variant="outlined"
                    />
                  </Grid2>
                  <Grid2 size={{xs:6, md:4, lg:3}}>
                    <TextField
                      name="mobile_number"
                      label={RequiredLabel(t('AddUser.MobileNo'), true)}
                      size="small"
                      value={values.mobile_number}
                      onChange={handleChange}
                      error={touched.mobile_number && !!errors.mobile_number}
                      fullWidth
                      variant="outlined"
                    />
                  </Grid2>
                  <Grid2 size={{xs:6, md:4, lg:3}}>
                    <TextField
                      name="username"
                      label={RequiredLabel(t('AddUser.Username'), true)}
                      size="small"
                      value={values.username}
                      onChange={handleUsernameChange}
                      error={touched.username && (!!errors.username || !!usernameError)}
                      helperText={
                        usernameError
                          ? <span style={{color:'#d32f2f'}}>{usernameError}</span>
                          : usernameSuccess
                            ? <span style={{color:'#388e3c'}}>{usernameSuccess}</span>
                            : ''
                      }
                      fullWidth
                      variant="outlined"
                      autoComplete="off"
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 6, md: 4, lg: 3 }}>
                    <Autocomplete
                      options={
                        languageOptions.some(opt => opt.code === (values.language))
                          ? languageOptions
                          : [
                            ...languageOptions,
                            values.language && values.language_name
                              ? { code: values.language, name: values.language_name }
                              : null
                          ].filter(Boolean)
                      }
                      getOptionLabel={(option) => option?.name ?? ''}
                      value={
                        languageOptions.find(opt => opt.code === (values.language))
                        || (values.language && values.language_name ? { code: values.language, name: values.language_name } : null)
                      }
                      onChange={(_, newValue) => {
                        setFieldValue('language', newValue ? newValue.code : '');
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="language"
                          label={RequiredLabel(t('AddUser.DefaultLanguage') || 'Default Language',true)}
                          size="small"
                          error={touched.language && !!errors.language}
                          variant="outlined"
                        />
                      )}
                      fullWidth
                    />
                  </Grid2>
                  {!editUserId && (
                    <>
                      <Grid2 size={{xs:6, md:4, lg:3}}>
                        <TextField
                          name="password"
                          label={RequiredLabel(t('AddUser.Password'), true)}
                          size="small"
                          type={showPassword ? 'text' : 'password'}
                          value={values.password ?? ''}
                          onChange={handleChange}
                          error={touched.password && !!errors.password}
                          helperText={(() => {
                            const { text, color } = getPasswordHelperText();
                            return text ? <span style={{ color }}>{text}</span> : '';
                          })()}
                          fullWidth
                          variant="outlined"
                          autoComplete="new-password"
                          InputProps={{
                            endAdornment: (
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={() => setShowPassword((show) => !show)}
                                edge="end"
                                size="small"
                              >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            )
                          }}
                        />
                      </Grid2>
                      <Grid2 size={{xs:6, md:4, lg:3}}>
                        <TextField
                          name="confirm_password"
                          label={RequiredLabel(t('AddUser.ConfirmPassword'), true)}
                          size="small"
                          type={showConfirmPassword ? 'text' : 'password'}
                          value={values.confirm_password ?? ''}
                          onChange={handleChange}
                          error={touched.confirm_password && !!errors.confirm_password}
                          helperText={(() => {
                            const { text, color } = getConfirmPasswordHelperText();
                            return text ? <span style={{ color }}>{text}</span> : '';
                          })()}
                          fullWidth
                          variant="outlined"
                          autoComplete="new-password"
                          InputProps={{
                            endAdornment: (
                              <IconButton
                                aria-label="toggle confirm password visibility"
                                onClick={() => setShowConfirmPassword((show) => !show)}
                                edge="end"
                                size="small"
                              >
                                {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            )
                          }}
                        />
                      </Grid2>
                    </>
                  )}

                  {values.user_type === 'EMPLOYEE' && <>
                    <Grid2 size={{xs:6, md:4, lg:3}}>
                      <Autocomplete
                        options={configurations?.DESIGNATION || []}
                        value={configurations?.DESIGNATION?.find(opt => opt.code === values.designation) || null}
                        onChange={(_, newValue) => setFieldValue('designation', newValue ? newValue.code : '')}
                        getOptionLabel={option => option.name}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name="designation"
                            label={t('AddUser.Designation')}
                            size="small"
                            error={touched.designation && !!errors.designation}
                            variant="outlined"
                          />
                        )}
                        fullWidth
                        isOptionEqualToValue={(option, value) => option.code === value.code}
                      />
                    </Grid2>
                    <Grid2 size={{xs:6, md:4, lg:3}}>
                      <Autocomplete
                        options={roleOptions}
                        value={roleOptions?.find(opt => opt.id === values.role) || null}
                        onChange={(_, newValue) => setFieldValue('role', newValue ? newValue.id : null)}
                        getOptionLabel={option => option.name_label || option.name}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name="role"
                            label={t('AddUser.UserType')}
                            size="small"
                            error={touched.role && !!errors.role}
                            variant="outlined"
                          />
                        )}
                        fullWidth
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                      />
                    </Grid2>
                  </>}

                  {values.user_type === 'DOCTOR' && <>
                    <Grid2 size={{xs:6, md:4, lg:3}}>
                      <Autocomplete
                        options={configurations?.SPECIALIZATION || []}
                        value={configurations?.SPECIALIZATION?.find(opt => opt.code === values.specialization) || null}
                        onChange={(_, newValue) => setFieldValue('specialization', newValue ? newValue.code : '')}
                        getOptionLabel={option => option.name}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name="specialization"
                            label={RequiredLabel(t('AddUser.Specialization'), true)}
                            size="small"
                            error={touched.specialization && !!errors.specialization}
                            variant="outlined"
                          />
                        )}
                        fullWidth
                        isOptionEqualToValue={(option, value) => option.code === value.code}
                      />
                    </Grid2>
                    <Grid2 size={{xs:6, md:4, lg:3}}>
                      <Autocomplete
                        options={configurations?.DOCTOR_TYPE || []}
                        value={configurations?.DOCTOR_TYPE?.find(opt => opt.code === values.doctor_type) || null}
                        onChange={(_, newValue) => setFieldValue('doctor_type', newValue ? newValue.code : '')}
                        getOptionLabel={option => option.name}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name="doctor_type"
                            label={RequiredLabel(t('AddUser.DoctorType'))}
                            size="small"
                            error={touched.doctor_type && !!errors.doctor_type}
                            variant="outlined"
                          />
                        )}
                        fullWidth
                        isOptionEqualToValue={(option, value) => option.code === value.code}
                      />
                    </Grid2>
                    <Grid2 size={{xs:6, md:4, lg:3}}>
                      <Autocomplete
                        options={doctorCategoryOptions || []}
                        value={doctorCategoryOptions?.find(opt => opt.id === values.role) || null}
                        onChange={(_, newValue) => setFieldValue('role', newValue ? newValue.id : null)}
                        getOptionLabel={option => option.name_label || option.name}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name="role"
                            label={t('AddUser.DoctorCategory')}
                            size="small"
                            error={touched.role && !!errors.role}
                            variant="outlined"
                          />
                        )}
                        fullWidth
                        // isOptionEqualToValue={(option, value) => option.id === value.id}
                      />
                    </Grid2>

                    <Grid2 size={{xs:6, md:4, lg:3}}>
                      <Autocomplete
                        options={[]} 
                        value={values.marketing_executive || ''}
                        onChange={(_, newValue) => setFieldValue('marketing_executive', newValue)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name="marketing_executive"
                            label={t('AddUser.MarketingExecutives')}
                            size="small"
                            error={touched.marketing_executive && !!errors.marketing_executive}
                            variant="outlined"
                          />
                        )}
                        fullWidth
                      />
                    </Grid2>

                  </>}
              
                </Grid2>

                <Box sx={{ mt: 5, mb: 2 }}>
                  <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 2 }}>
                    {t('AddUser.AddDetails')}
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      background: '#FCFCFC',
                      borderRadius: 2,
                      boxShadow: '0px 2px 8px 0px rgba(44, 44, 44, 0.04)',
                      p: 1,
                      mb: 2,
                      alignItems: 'center',
                      minHeight: 56,
                    }}
                  >
                    {tabList.map((tab, idx) => (
                      <Button
                        key={tab}
                        onClick={() => setActiveTab(idx)}
                        sx={{
                          flex: 1,
                          borderRadius: 2,
                          boxShadow: idx === activeTab ? '0px 2px 8px 0px rgba(44, 44, 44, 0.08)' : 'none',
                          background: idx === activeTab ? '#fff' : 'transparent',
                          color: idx === activeTab ? '#E25E3E' : '#222',
                          fontWeight: idx === activeTab ? 600 : 400,
                          fontSize: 18,
                          height: 48,
                          transition: 'all 0.2s',
                          mr: idx !== tabList.length - 1 ? 2 : 0,
                          border: 'none',
                          '&:hover': {
                            background: idx === activeTab ? '#fff' : '#f5f5f5',
                          },
                        }}
                        disableElevation
                        disableRipple
                      >
                        {t(`AddUser.${tab.replace(/ /g, '')}`) || tab}
                      </Button>
                    ))}
                  </Box>
                </Box>

                {activeTab === 0 && (
                  <Grid2 container spacing={3} mt={4}>
                    <Grid2  size={{xs:6, md:4, lg:3}}>
                      <Autocomplete
                        options={configurations?.MARITAL_STATUS || []}
                        value={configurations?.MARITAL_STATUS?.find(opt => opt.code === (values.additional_info && typeof values.additional_info === 'object' ? values.additional_info.marital_status || '' : '')) || null}
                        onChange={(_, newValue) => setFieldValue('additional_info.marital_status', newValue ? newValue.code : '')}
                        getOptionLabel={option => option.name}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name="additional_info.marital_status"
                            label="Marital Status"
                            size="small"
                            variant="outlined"
                          />
                        )}
                        fullWidth
                        isOptionEqualToValue={(option, value) => option.code === value.code}
                      />
                    </Grid2>
                    <Grid2  size={{xs:6, md:4, lg:3}}>
                      <TextField
                        label={t('AddUser.EmployeeNumber')}
                        name="additional_info.employee_number"
                        value={values?.additional_info?.employee_number || ''}
                        onChange={handleChange}
                        size="small"
                        fullWidth
                      />
                    </Grid2>
                    <Grid2  size={{xs:6, md:4, lg:3}}>
                      <TextField
                        label={t('AddUser.PFNumber')}
                        name="additional_info.pf_number"
                        value={values?.additional_info?.pf_number || ''}
                        onChange={handleChange}
                        size="small"
                        fullWidth
                      />
                    </Grid2>
                    <Grid2  size={{xs:6, md:4, lg:3}}>
                      <TextField
                        label={RequiredLabel(t('AddUser.PANNumber'), true)}
                        name="additional_info.pan_number"
                        value={values?.additional_info?.pan_number || ''}
                        onChange={handleChange}
                        error={touched.additional_info?.pan_number && !!errors.additional_info?.pan_number}
                        size="small"
                        fullWidth
                      />
                    </Grid2>
                    {values.user_type === 'DOCTOR' && (
                      <Grid2  size={{xs:6, md:4, lg:3}}>
                        <TextField
                          label={t('AddUser.RegistrationNumber')}
                          name="additional_info.registration_number"
                          value={values?.additional_info?.registration_number || ''}
                          onChange={handleChange}
                          size="small"
                          fullWidth
                        />
                      </Grid2>
                    )}
                    <Grid2  size={{xs:6, md:4, lg:3}}>
                      <TextField
                        label={t('AddUser.AccessCardNumber')}
                        name="additional_info.access_card_number"
                        value={values?.additional_info?.access_card_number || ''}
                        onChange={handleChange}
                        size="small"
                        fullWidth
                      />
                    </Grid2>
                    <Grid2  size={{xs:6, md:4, lg:3}}>
                      <TextField
                        label={t('AddUser.Experience')}
                        name="additional_info.experience"
                        value={values?.additional_info?.experience || ''}
                        onChange={handleChange}
                        size="small"
                        fullWidth
                      />
                    </Grid2>
                    <Grid2  size={{xs:6, md:4, lg:3}}>
                      <TextField
                        label={t('AddUser.Education')}
                        name="additional_info.education"
                        value={values?.additional_info?.education || ''}
                        onChange={handleChange}
                        size="small"
                        fullWidth
                      />
                    </Grid2>
                    {values.user_type === 'EMPLOYEE' && (
                      <Grid2 size={{xs:6, md:4, lg:3}} sx={{ display: 'flex', alignItems: 'center' }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={!!values?.additional_info?.is_discharge_approve}
                              onChange={e => setFieldValue('additional_info.is_discharge_approve', e.target.checked)}
                              name="additional_info.is_discharge_approve"
                              color="primary"
                            />
                          }
                          label={t('AddUser.IsDischargeApprove')}
                        />
                      </Grid2>
                    )}
                    <Grid2  size={{xs:6, md:4, lg:3}} sx={{ display: 'flex', alignItems: 'center' }}>
                      <UploadButton
                        label={t('AddUser.UploadDocuments')}
                        onClick={() => setUploadModalOpen(true)}
                        onViewClick={() => setIsViewModalOpen(true)}
                        fileCount={uploadedFiles.length}
                        variant="outlined"
                        size="small"
                        height={40}
                      />
                    </Grid2>
                  </Grid2>
                )}
                {activeTab === 1 && (
                  <Box >
                    <Grid2 container spacing={2} alignItems="center">
                      <Grid2 size={{ xs: 12, md: 4 }}>
                        <Autocomplete
                          options={clinicOptions}
                          getOptionLabel={option => option.name}
                          value={selectedClinic}
                          onChange={(_, newValue) => {
                            setSelectedClinic(newValue);
                            setSelectedDepartment([]); // Reset departments on clinic change
                          }}

                          renderInput={params => (
                            <TextField {...params} label={t('AddUser.Clinic') || 'Clinic'} size="small" fullWidth 
                              error={Boolean(touched.clinic_departments && errors.clinic_departments)}
                            
                            />
                          )}
                          isOptionEqualToValue={(option, value) => option.id === value.id}
                        />
                      </Grid2>
                      <Grid2 size={{ xs: 12, md: 4 }}>
                        <Autocomplete
                          multiple
                          options={departmentOptions}
                          getOptionLabel={option => option.name}
                          value={Array.isArray(selectedDepartment) ? selectedDepartment : []}
                          onChange={(_, newValue) => {
                            setSelectedDepartment(newValue);
                          }}
                          renderInput={params => (
                            <TextField
                              {...params}
                              label={t('AddUser.Department') || 'Department'}
                              size="small"
                              fullWidth
                              error={Boolean(touched.clinic_departments && errors.clinic_departments)}
                            
                            />
                          )}
                          isOptionEqualToValue={(option, value) => option.id === value.id}
                          disabled={!selectedClinic}
                        />
                      </Grid2>
                      <Grid2 size={{ xs: 12, md: 4 }} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                          variant="outlined"
                          sx={{
                            minWidth: 100,
                            borderRadius: 3,
                            background: '#4B4B4B',
                            color: '#fff',
                            fontWeight: 600,
                            cursor: (!selectedClinic || !selectedDepartment || !Array.isArray(selectedDepartment) || selectedDepartment.length === 0) ? 'not-allowed' : 'pointer',
                            opacity: (!selectedClinic || !selectedDepartment || !Array.isArray(selectedDepartment) || selectedDepartment.length === 0) ? 0.8 : 1
                          }}
                          startIcon={<span style={{fontSize:18}}>+</span>}
                          onClick={() => {
                            if (
                              selectedClinic &&
                              Array.isArray(selectedDepartment) &&
                              selectedDepartment.length > 0
                            ) {
                              setFieldValue('clinic_departments', [
                                ...values.clinic_departments,
                                {
                                  clinic: selectedClinic.id,
                                  clinic_name: selectedClinic.name,
                                  department: selectedDepartment.map(dep => ({ id: dep.id, name: dep.name })),
                                  is_default: values.clinic_departments.length === 0 
                                }
                              ]);
                              setSelectedClinic(null);
                              setSelectedDepartment([]);
                            }
                          }}
                          disabled={
                            !selectedClinic ||
                            !selectedDepartment ||
                            !Array.isArray(selectedDepartment) ||
                            selectedDepartment.length === 0
                          }
                        >
                          {tGeneral('Add')}
                        </Button>
                      </Grid2>
                    </Grid2>
                    {values.clinic_departments.length > 0 && (
                      <Box sx={{ mt: 3, borderRadius: 2, p: 2 }}>
                        <Table size="small">
                          <TableHead sx={{ background: '#F7F7F7' }}>
                            <TableRow >
                              <TableCell sx={{ fontWeight: 600, color: '#888', width: '25%', py: 2 }}>{t('AddUser.Clinic')}</TableCell>
                              <TableCell sx={{ fontWeight: 600, color: '#888', width: '75%', py: 2 }}>{t('AddUser.Department')}</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {values.clinic_departments.map((cd, idx) => (
                              <TableRow key={cd.clinic + '-' + idx}>
                                <TableCell sx={{ fontWeight: 600, fontSize: 18 }}>
                                  <IconButton
                                    onClick={() => {
                                      setFieldValue('clinic_departments', values.clinic_departments.filter((_, i) => i !== idx));
                                    }}
                                    sx={{ color: '#E25E3E', border: '1.5px solid #F7C5B7', background: '#fff', width: 32, height: 32, marginRight: 2, padding: 0, borderRadius: '50%' }}
                                  >
                                    <span style={{ fontSize: 22, fontWeight: 700 }}>×</span>
                                  </IconButton>
                                  {cd.clinic_name}
                                </TableCell>
                                <TableCell>

                                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                    {Array.isArray(cd.department) && cd.department.map((depObj, depIdx) => (
                                      <Box key={depObj.id + '-' + depIdx} sx={{ display: 'flex', alignItems: 'center', background: '#FFF3EF', color: '#222', borderRadius: 2, px: 2, py: 0.5, fontWeight: 500, fontSize: 16, mr: 1, mb: 1 }}>
                                        {depObj.name}
                                        <IconButton
                                          size="small"
                                          sx={{ ml: 1, color: '#E25E3E', p: 0.2 }}
                                          onClick={() => {
                                            const updated = values.clinic_departments.map((item, i) => {
                                              if (i === idx) {
                                                const newDept = item.department.filter((_, j) => j !== depIdx);
                                                return { ...item, department: newDept };
                                              }
                                              return item;
                                            }).filter(item => item.department.length > 0);
                                            setFieldValue('clinic_departments', updated);
                                          }}
                                        >
                                          <span style={{ fontSize: 18, fontWeight: 700 }}>×</span>
                                        </IconButton>
                                      </Box>
                                    ))}
                                  </Box>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </Box>
                    )}
                    {touched.clinic_departments && errors.clinic_departments && (
                      <Typography color="error" sx={{ mt: 1, ml: 1, fontSize: 14 }}>
                        {'Please add at least one clinic and its department.'}
                      </Typography>
                    )}
                  </Box>
                )}
                {activeTab === 2 && (
                  <Grid2 container spacing={3} mt={4}>
                    <Grid2 size={{xs:6, md:4, lg:3}}>
                      <TextField
                        label={t('AddUser.BankName')}
                        name="additional_info.bank_name"
                        value={values.additional_info?.bank_name || ''}
                        onChange={handleChange}
                        size="small"
                        fullWidth
                      />
                    </Grid2>
                    <Grid2 size={{xs:6, md:4, lg:3}}>
                      <TextField
                        label={t('AddUser.BranchName')}
                        name="additional_info.branch_name"
                        value={values.additional_info?.branch_name || ''}
                        onChange={handleChange}
                        size="small"
                        fullWidth
                      />
                    </Grid2>
                    <Grid2 size={{xs:6, md:4, lg:3}}>
                      <TextField
                        label={t('AddUser.AccountNumber')}
                        name="additional_info.account_number"
                        value={values.additional_info?.account_number || ''}
                        onChange={handleChange}
                        size="small"
                        fullWidth
                      />
                    </Grid2>
                    <Grid2 size={{xs:6, md:4, lg:3}}>
                      <TextField
                        label={t('AddUser.IFSC')}
                        name="additional_info.ifsc"
                        value={values.additional_info?.ifsc || ''}
                        onChange={handleChange}
                        size="small"
                        fullWidth
                      />
                    </Grid2>
                    <Grid2 size={{xs:12, md:8, lg:6}}>
                      <TextField
                        label={t('AddUser.BankAddress')}
                        name="additional_info.address"
                        value={values.additional_info?.address || ''}
                        onChange={handleChange}
                        size="small"
                        fullWidth
                        multiline
                        minRows={1}
                      />
                    </Grid2>
                  </Grid2>
                )}
                {activeTab === 3 && (
                  <Box>
                    <Grid2 container alignItems="center" spacing={2} mb={2}>
                      <Grid2 size={6}>
                        <Typography variant="h6" fontWeight={700}>
                          {t('AddUser.permenantAddress')}
                        </Typography>
                      </Grid2>
                      <Grid2 size={6} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Typography variant="h6" fontWeight={700}>
                          {t('AddUser.CommunicationAddress')}
                        </Typography>
                      
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <input
                            type="checkbox"
                            checked={values.additional_info?.address_same_as_permenant || false}
                            onChange={e => {
                              setFieldValue('additional_info.address_same_as_permenant', e.target.checked);
                              if (e.target.checked) {
                                setFieldValue('additional_info.communication_address_line1', values.additional_info?.permenant_address_line1);
                                setFieldValue('additional_info.communication_address_line2', values.additional_info?.permenant_address_line2);
                                setFieldValue('additional_info.communication_city', values.additional_info?.permenant_city);
                                setFieldValue('additional_info.communication_state', values.additional_info?.permenant_state);
                                setFieldValue('additional_info.communication_country', values.additional_info?.permenant_country);
                                setFieldValue('additional_info.communication_pincode', values.additional_info?.permenant_pincode);
                              }
                            }}
                            style={{ marginRight: 8 }}
                          />
                          <Typography>{t('AddUser.SameAspermenant')}</Typography>
                        </Box>
                      </Grid2>
                    </Grid2>
                    <Grid2 container spacing={3} mt={1}>
                      <Grid2 size={6}>
                        <Grid2 container spacing={2}>
                          <Grid2 size={12}>
                            <TextField
                              label={t('AddUser.AddressLine1')}
                              name="additional_info.permenant_address_line1"
                              value={values.additional_info?.permenant_address_line1 || ''}
                              onChange={handleChange}
                              size="small"
                              fullWidth
                            />
                          </Grid2>
                          <Grid2 size={12}>
                            <TextField
                              label={t('AddUser.AddressLine2')}
                              name="additional_info.permenant_address_line2"
                              value={values.additional_info?.permenant_address_line2 || ''}
                              onChange={handleChange}
                              size="small"
                              fullWidth
                            />
                          </Grid2>
                          <Grid2 size={6}>
                            <TextField
                              label={t('AddUser.City')}
                              name="additional_info.permenant_city"
                              value={values.additional_info?.permenant_city || ''}
                              onChange={handleChange}
                              size="small"
                              fullWidth
                            />
                          </Grid2>
                          <Grid2 size={6}>
                            <TextField
                              label={t('AddUser.State')}
                              name="additional_info.permenant_state"
                              value={values.additional_info?.permenant_state || ''}
                              onChange={handleChange}
                              size="small"
                              fullWidth
                            />
                          </Grid2>
                          <Grid2 size={6}>
                            <TextField
                              label={t('AddUser.Country')}
                              name="additional_info.permenant_country"
                              value={values.additional_info?.permenant_country || ''}
                              onChange={handleChange}
                              size="small"
                              fullWidth
                            />
                          </Grid2>
                          <Grid2 size={6}>
                            <TextField
                              label={t('AddUser.ZipCode')}
                              name="additional_info.permenant_pincode"
                              value={values.additional_info?.permenant_pincode || ''}
                              onChange={handleChange}
                              size="small"
                              fullWidth
                            />
                          </Grid2>
                        </Grid2>
                      </Grid2>
                      <Grid2 size={6}>
                        <Grid2 container spacing={2}>
                          <Grid2 size={12}>
                            <TextField
                              label={t('AddUser.AddressLine1')}
                              name="additional_info.communication_address_line1"
                              value={values.additional_info?.communication_address_line1 || ''}
                              onChange={e => {
                                setFieldValue('additional_info.communication_address_line1', e.target.value);
                                if (values.additional_info?.address_same_as_permenant) setFieldValue('additional_info.permenant_address_line1', e.target.value);
                              }}
                              size="small"
                              fullWidth
                              disabled={values.additional_info?.address_same_as_permenant}
                            />
                          </Grid2>
                          <Grid2 size={12}>
                            <TextField
                              label={t('AddUser.AddressLine2')}
                              name="additional_info.communication_address_line2"
                              value={values.additional_info?.communication_address_line2 || ''}
                              onChange={e => {
                                setFieldValue('additional_info.communication_address_line2', e.target.value);
                                if (values.additional_info?.address_same_as_permenant) setFieldValue('additional_info.permenant_address_line2', e.target.value);
                              }}
                              size="small"
                              fullWidth
                              disabled={values.additional_info?.address_same_as_permenant}
                            />
                          </Grid2>
                          <Grid2 size={6}>
                            <TextField
                              label={t('AddUser.City')}
                              name="additional_info.communication_city"
                              value={values.additional_info?.communication_city || ''}
                              onChange={e => {
                                setFieldValue('additional_info.communication_city', e.target.value);
                                if (values.additional_info?.address_same_as_permenant) setFieldValue('additional_info.permenant_city', e.target.value);
                              }}
                              size="small"
                              fullWidth
                              disabled={values.additional_info?.address_same_as_permenant}
                            />
                          </Grid2>
                          <Grid2 size={6}>
                            <TextField
                              label={t('AddUser.State')}
                              name="additional_info.communication_state"
                              value={values.additional_info?.communication_state || ''}
                              onChange={e => {
                                setFieldValue('additional_info.communication_state', e.target.value);
                                if (values.additional_info?.address_same_as_permenant) setFieldValue('additional_info.permenant_state', e.target.value);
                              }}
                              size="small"
                              fullWidth
                              disabled={values.additional_info?.address_same_as_permenant}
                            />
                          </Grid2>
                          <Grid2 size={6}>
                            <TextField
                              label={t('AddUser.Country')}
                              name="additional_info.communication_country"
                              value={values.additional_info?.communication_country || ''}
                              onChange={e => {
                                setFieldValue('additional_info.communication_country', e.target.value);
                                if (values.additional_info?.address_same_as_permenant) setFieldValue('additional_info.permenant_country', e.target.value);
                              }}
                              size="small"
                              fullWidth
                              disabled={values.additional_info?.address_same_as_permenant}
                            />
                          </Grid2>
                          <Grid2 size={6}>
                            <TextField
                              label={t('AddUser.ZipCode')}
                              name="additional_info.communication_pincode"
                              value={values.additional_info?.communication_pincode || ''}
                              onChange={e => {
                                setFieldValue('additional_info.communication_pincode', e.target.value);
                                if (values.additional_info?.address_same_as_permenant) setFieldValue('additional_info.permenant_pincode', e.target.value);
                              }}
                              size="small"
                              fullWidth
                              disabled={values.additional_info?.address_same_as_permenant}
                            />
                          </Grid2>
                        </Grid2>
                      </Grid2>
                    </Grid2>
                  </Box>
                )}

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 8, gap: 2 }}>
                  <Button variant="outlined" color="inherit" sx={{ minWidth: 120, borderRadius: 3 }} onClick={() =>  navigate('/ai/configuration/user')}>
                    {tGeneral('Cancel')}
                  </Button>
                  <Button
                    variant="contained"
                    color="inherit"
                    sx={{ minWidth: 180, borderRadius: 3, background: '#4B4B4B', color: '#fff', fontWeight: 600 }}
                    type="submit"
                  >
                    {editUserId?t('AddUser.UpdateUser') :t('AddUser.CreateNewUser')}
                  </Button>
                </Box>
              </Form>

              {/* Upload Modal */}
              <ImageUploadModal
                open={uploadModalOpen}
                onClose={() => setUploadModalOpen(false)}
                onSave={(images) => {
                  setUploadedFiles(images);
                  // Convert UploadedImageType to FileUpload format with metadata for API
                  const fileObjs = images.map(img => ({
                    file: img.image,
                    file_name: img.name,
                    file_size: img.sizeBytes,
                    file_extension: img.file_extension,
                  }));
                  setFieldValue('files', fileObjs);
                  setUploadModalOpen(false);
                }}
                uploadedImages={uploadedFiles}
                onRemove={(images) => {
                  setUploadedFiles(images);
                  const fileObjs = images.map(img => ({
                    file: img.image,
                    file_name: img.name,
                    file_size: img.sizeBytes,
                    file_extension: img.file_extension,
                  }));
                  setFieldValue('files', fileObjs);
                }}
                maxFileSizeMB={5}
              />

              {/* View Modal */}
              <ImageUploadModal
                open={isViewModalOpen}
                onClose={() => setIsViewModalOpen(false)}
                onSave={() => setIsViewModalOpen(false)}
                uploadedImages={uploadedFiles}
                title={tSurgery('viewDocuments')}
                viewMode={true}
              />

              <ConfirmationModal
                open={openConfirmDialog}
                handleClose={() => setOpenConfirmDialog(false)} 
                onConfirm={() => {
                  setOpenConfirmDialog(false);
                  submitForm();
                }}
                title={t('AddUser.Confirm')}
                contentMessage={tGeneral('AreYouSureSubmit')}
                type={'warning'}
              />
            </Box>


          </ThemeProvider>
        );
      }}
    </Formik>
  );
};


export default AddUser;